<div class="dialog-title">
  {{ title }}
</div>


<div class="value-container" >
  <div fxLayout="row wrap" matLine>
    <div class="full-col">
      <div class="xsDesc-f">
        Name
      </div>
      <div class="value-f">
        {{eLaunchData?.name || '-'}}
      </div>
    </div>

    <div class="full-col" >
      <div class="xsDesc-f">
        E-Launch Code
      </div>
      <div class="value-f">
        {{eLaunchData?.code || '-'}}
      </div>
    </div>
    <div class="full-col" >
      <div class="xsDesc-f">
       Event Publish Date & Time
      </div>
      <div class="value-f" mat-line>
        {{eLaunchData?.publishDate | date : 'medium'}}
      </div>
    </div>
    <div class="full-col" >
      <div class="xsDesc-f">
        Booking Start Date & Time
      </div>
      <div class="value-f" mat-line>
        {{eLaunchData?.startDate | date : 'medium'}}
      </div>
    </div>
    <div class="full-col" >
      <div class="xsDesc-f">
        End Date & Time
      </div>
      <div class="value-f" mat-line>
        {{eLaunchData?.endDate  | date : 'medium'}}
      </div>
    </div>
    <div class="full-col" >
      <div class="xsDesc-f">
        Termination Date & Time
      </div>
      <div class="value-f" >
        {{eLaunchData?.terminationDate | date : 'medium'}}
      </div>
    </div>

  </div>
</div>